import { Merc } from './entity_demo_client';

export const MERC_LIST: Merc[] = [{
  portrait: 1,
  attack: 2, defense: 2,
  hp: 10, hp_max: 10,
  cost: 10,
  realm: 'phys',
}, {
  portrait: 9,
  hp: 12, hp_max: 12,
  attack: 2, defense: 2,
  cost: 10,
  realm: 'spirit',

}, {
  portrait: 2,
  attack: 2, defense: 5,
  hp: 15, hp_max: 15,
  cost: 60,
  realm: 'phys',
}, {
  portrait: 10,
  attack: 5, defense: 1,
  hp: 10, hp_max: 10,
  cost: 70,
  realm: 'spirit',

}, {
  portrait: 3,
  attack: 6, defense: 1,
  hp: 10, hp_max: 10,
  cost: 400,
  realm: 'phys',
}, {
  portrait: 11,
  attack: 3, defense: 15,
  hp: 12, hp_max: 12,
  cost: 500,
  realm: 'spirit',

}, {
  portrait: 4,
  attack: 2, defense: 0,
  hp: 1, hp_max: 1,
  cost: 1,
  realm: 'phys',
}, {
  portrait: 12,
  attack: 1, defense: 0,
  hp: 2, hp_max: 2,
  cost: 1,
  realm: 'spirit',
}];
